import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  getIsPageNameDetail,
  getIsPageNameEdit,
  getIsPageNameEditDischarge,
  getIsPageNameNewAdmission,
  getIsPageNameReconsider,
  isFormElemEditable,
} from '../../modules/crm/inPatient/service/crmUtils';
import { RootState } from '../../store';

export function useGetFormConfig(props: any): any {
  let rules = [];
  const classes = [];
  const { pathname } = useLocation();

  const { detail } = props;
  const {
    key, size, offset = null, type, isBillDetail, isBillDropDown, isFormDynamic, onClear, addonBefore, onChange = (): void => { },
    isLoading, defaultValue, showSearch, mode, checkBoxColSize, form, itemNoStyle,
    label: elementLabel, labelClass, disabledDate, onSearch = (): void => {}, customOption, onSelect = (): void => {},
    isOptionsLoading, disabled: elemDisabled, claimDetailBackup, allowClear = true, rules: additionalRules = [],
    allowNegative, noOfDecimalAllowed = 2, hideLabel = false, direction, onBlur, arrToStr, placeholder: placeholderProp,
    mainLabel, rightFooterText: rFooterText, allowOptionDisabled, disabledReason, isEditableInDetail, dataTestname, dataTestDrop,
    showVerified, onEdit, checked, applyStyles, isEditable, hasDisabledPayers, onPanelLeave, showPrefix, showbtnIcon, onDropdownToggle,
    isMemberAge, floatLabelWithCss, ref, contentEditable, suffix, nextStatus,
  } = detail;
  let { disabled, required, hidden, options } = detail;
  const { showTime } = detail;
  const { t } = useTranslation();
  const { payerList: { formControlConfig }, admissionDetails: { claimDetails } } =
    useSelector((state: RootState): RootState =>
      state);

  const {
    label: configLabel = key, placeholder: configPlaceholder, required: requiredConf = false, hidden: hiddenConf = false,
    readable = false, editFor = [], tooltip, rightFooterText, visible, removeOther, isFieldvisible, showInDetailOnlyIfValue,
  } = (formControlConfig[key] || {});
  let finalrFooter = null;
  if (rFooterText || rFooterText === null) {
    finalrFooter = rFooterText;
  } else {
    finalrFooter = rightFooterText;
  }
  const isNewAdmission = getIsPageNameNewAdmission(pathname);
  const isEdit = getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) || getIsPageNameReconsider(pathname);
  const isDetail = getIsPageNameDetail(pathname);

  if ((isEdit) && formControlConfig[key]) {
    disabled = true;
    if (isFormElemEditable(editFor, claimDetails) || isEditable) {
      disabled = false;
    }
  }

  let formVal;
  if (claimDetailBackup) {
    formVal = claimDetailBackup[key];
  }
  required = (required === undefined) ? requiredConf : required;

  if (
    (!formVal
      || (Array.isArray(formVal) && !formVal?.length)
      || (typeof formVal === 'object' && isEmpty(formVal)))
      && required
      && formVal !== 0
  ) {
    disabled = false;
  }

  disabled = (elemDisabled === undefined) ? disabled : elemDisabled;

  rules = [...additionalRules];
  if (type) {
    rules.push({ type });
  }

  if (required) {
    rules.push({ required });
  }
  if (isBillDetail) {
    classes.push('inline-bill-detail');
  }
  if (isBillDropDown) {
    classes.push('inline-bill-dropdown');

  }
  if (applyStyles) {
    classes.push('detail-values');
  }
  if (isFormDynamic) {
    classes.push('label-title-dynamic');
  }

  disabled = (disabled === undefined) ? readable : disabled;
  hidden = (hidden === undefined) ? hiddenConf : hidden;

  if (visible && visible?.length > 0) {
    hidden = !(
      (isNewAdmission && visible.includes('NEW_ADMISSION')) ||
      (isEdit && visible.includes('EDIT')) ||
      (isDetail && visible.includes('DETAIL'))
    );
  }

  if (isFieldvisible && !isEmpty(isFieldvisible)) {
    hidden = !(
      (isNewAdmission && isFieldvisible.includes('NEWADMISSION')) ||
      (nextStatus && isFieldvisible.includes(nextStatus)) ||
      (isDetail && isFieldvisible.includes('DETAIL') && (!showInDetailOnlyIfValue || formVal))
    );
  }
  const finalLabel = elementLabel ? elementLabel : configLabel;
  const label = t(`translation:${finalLabel}`);

  let placeholder: any = placeholderProp;
  if (configPlaceholder && Array.isArray(configPlaceholder)) {
    placeholder = configPlaceholder.map((element: string): any => t(`translation:${element}`));
  } else if (configPlaceholder && !Array.isArray(configPlaceholder)) {
    placeholder = t(`translation:${configPlaceholder}`);
  }

  if (options?.length) {
    options = options.map((option: any): any => {
      let name; let value;
      if (typeof option === 'string') {
        name = option;
        value = option;
      } else {
        if (option !== undefined) {
          const { name: nameOption, value: valueOption } = option;
          name = nameOption;
          value = valueOption;
        }
      }

      if (formControlConfig[name]) {
        const { label: configLabelOption } = formControlConfig[name];
        name = configLabelOption;
      }
      return {
        ...option,
        value,
        name: t(`translation:${name}`),
      };
    });
  }

  return {
    ...detail,
    hidden, key, size, type, addonBefore, onChange, isLoading, isEdit, classes, disabled,
    required, label, placeholder, rules, defaultValue, showSearch, mode, options, checkBoxColSize,
    form, itemNoStyle, isBillDetail, isBillDropDown, onClear, showTime, labelClass, disabledDate, onSearch, customOption, onSelect,
    isOptionsLoading, allowClear, allowNegative, noOfDecimalAllowed, hideLabel, offset, direction, onBlur,
    arrToStr, tooltip, mainLabel, rightFooterText: (finalrFooter), allowOptionDisabled,
    disabledReason, isEditableInDetail, removeOther, dataTestname, dataTestDrop, isFormDynamic, showVerified, onEdit, checked,
    hasDisabledPayers, onPanelLeave, showPrefix, showbtnIcon, onDropdownToggle, isMemberAge, floatLabelWithCss, ref, contentEditable,
    suffix,
  };
}
